import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { getURLToDownloadReport } from '@/services/get-url-to-download-report'

export function useDownloadFileFromReport(id: string) {
  return useMutation(
    async () => {
      const url = await getURLToDownloadReport(id, 'economy')

      const link = document.createElement('a')
      link.href = url

      link.click()
    },
    {
      onError(e: any) {
        toast.error(
          'Ocorreu um erro ao realizar o download dos arquivos: ' + e.message,
        )
      },
    },
  )
}
